import { atom } from "jotai";
import { getUrlParams } from "./derived-url-logic";

export interface FilterCampaigns {
  platform: string;
  account_id?: string;
  campaign_ids?: string[];
  adset_ids?: string[];
}

/**
 * Returns true if the filter is scoped to a specific account, campaign, or ad set.
 */
export function isSpecificFilter(f: FilterCampaigns): boolean {
  return !!(f.account_id || f.campaign_ids?.length || f.adset_ids?.length);
}

/**
 * Returns true if the filter is a bare "all accounts" sentinel for a platform.
 */
export function isAllAccountsSentinel(f: FilterCampaigns): boolean {
  return !isSpecificFilter(f) && !!f.platform;
}

/**
 * Factory to create a consistent "all accounts" sentinel for a platform.
 */
export function makeAllAccountsFilter(platform: string): FilterCampaigns {
  return { platform: platform.toLowerCase() };
}

// Base atom for the filter campaigns state
export const filterCampaignsAtom = atom<FilterCampaigns[]>([]);

// Derived atom that handles initialization from URL params
export const filterCampaignsWithUrlAtom = atom(
  (get) => get(filterCampaignsAtom),
  (_, set, newValue: FilterCampaigns[] | null) => {
    getUrlParams({
      newValue,
      atom: filterCampaignsAtom,
      set,
      searchParamKey: "platform_filters",
      defaultValue: []
    });
  }
);
